// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.AcceptRentAmountChangeWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AcceptRentAmountChangeWebApiRequestDto, AcceptRentAmountChangeWebApiResponseDto } from '../..';

export const AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange_Path = '/api/web/v1/acceptRentAmountChange';

/**
 * accept rent amount change
 */
export const AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange = (
  postData: AcceptRentAmountChangeWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AcceptRentAmountChangeWebApiRequestDto, AcceptRentAmountChangeWebApiResponseDto>(
    {
      endpoint: AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
